import {$qs, $qsAll} from '../../@shared/ts/dom';

declare const peachpay_admin: PeachPayAdminData;

function deactivationFeedbackModal() {
	$qs<HTMLFormElement>('#peachpay-deactivate-feedback-form', $form => {
		$form?.addEventListener('change', handleChange);
		$form?.addEventListener('submit', handleSubmit);

		$qs('#deactivate-peachpay-for-woocommerce')?.addEventListener('click', handleShowModal);
		document.addEventListener('click', handleHideModal);
	});
}

document.addEventListener('DOMContentLoaded', deactivationFeedbackModal);

/**
 * Shows the deactivation feedback modal.
 */
function handleShowModal(event: MouseEvent) {
	event.preventDefault();
	event.stopPropagation();
	event.stopImmediatePropagation();

	$qs('#ppModal', $el => {
		$el.style.display = 'block';
	});

	$qs<HTMLAnchorElement>('#peachpay-skip-feedback', $el => {
		$el.href = deactivationURL();
	});
}

/**
 * Hides the deactivation feedback modal.
 */
function handleHideModal(event: MouseEvent) {
	const $modal = $qs('#ppModal');
	if ($modal?.style.display === 'block' && !(event.target as HTMLElement)?.closest('#modal-content')) {
		$modal.style.display = '';
		$qs<HTMLFormElement>('#peachpay-deactivate-feedback-form', $form => {
			$form.reset();
			$form.dispatchEvent(new Event('change'));
		});
	}
}

/**
 * Handles form field changes.
 */
function handleChange() {
	$qsAll('[data-show-if]', $optionalEl => {
		const showId = $optionalEl.dataset['showIf'] ?? '';
		const $target = document.getElementById(showId) as HTMLInputElement | null;
		if ($target?.checked) {
			$optionalEl.style.display = 'block';
			$optionalEl.removeAttribute('disabled');
		} else {
			$optionalEl.style.display = '';
			$optionalEl.setAttribute('disabled', 'true');
		}
	});
}

/**
 * Handles submitting deactivation feedback.
 */
async function handleSubmit(event: SubmitEvent) {
	event.preventDefault();

	const $form = $qs<HTMLFormElement>('#peachpay-deactivate-feedback-form');
	if (!$form?.reportValidity()) {
		return;
	}

	$qs('#loading-spinner', $el => {
		$el.classList.remove('hide');
	});
	$qs('#pp-deactivate-content', $el => {
		$el.classList.add('hide');
	});

	const formData = new FormData($form);
	formData.append('action', 'pp-deactivation-feedback');
	formData.append('security', peachpay_admin.nonces.deactivation_feedback);

	await fetch(peachpay_admin.admin_ajax, {
		method: 'POST',
		body: formData,
	});

	window.location.href = deactivationURL();
}

function deactivationURL(): string {
	return $qs<HTMLAnchorElement>('#deactivate-peachpay-for-woocommerce')?.href as unknown as string;
}
